import { getProjectListingById } from '@/api/v4/project-listings.api';
import { QueryKey } from '@/config/query-client';
import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { useQuery } from '@tanstack/react-query';

export const useProjectListingById = (projectListingId: string) => {
  return useQuery({
    queryKey: [QueryKey.ProjectListingById, projectListingId],
    queryFn: () => getProjectListingById(projectListingId),
    enabled: !!projectListingId,
    staleTime: getTimeInMs(5, 'minute'),
  });
};
